var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.routesToHide.includes(_vm.$router.currentRoute.path))?_c('Navbar'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }